export const GET_COUNTIES_SUCCESS = 'GET_COUNTIES_SUCCESS';
export const GET_COUNTIES_ERROR = 'GET_COUNTIES_ERROR';
export const GET_PARTNERS_SUCCESS = 'GET_PARTNERS_SUCCESS';
export const GET_PARTNERS_ERROR = 'GET_PARTNERS_ERROR';